//cn.js

const cn = {
    message: {
        'GroupMember': "团队成员",
        'Publications': "已发表文章",
        'PhD': "博士生",
        'Master': "硕士生",
        'Teacher': '教师',
        'Lang': '语言',
        'Web': "网页数据库",
        'Graduated': '毕业生',
        'Intro': "简介",
        'CV': "履历",
        'Study': "科研方向",
        'News': "新闻",
    },
};

export default cn